import { animate, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, OnInit, HostListener } from '@angular/core';
import { ContractEntityService } from '../../../services/contract-entity.service';
import { ContractEntityInfo } from '../../../models/views/contract-entity-info';

@Component({
  selector: 'app-footer-basic',
  templateUrl: './footer-basic.component.html',
  styleUrls: ['./footer-basic.component.css'],
})
export class FooterBasicComponent implements OnInit {
  info: ContractEntityInfo = new ContractEntityInfo();
  currentDate = new Date();
  showResult = false;
  isBrowser = false;
  isCollapsed = true;
  constructor(@Inject(PLATFORM_ID) platformId: Object, private contractEntityService: ContractEntityService) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    // this.contractEntityService.getInfo().subscribe((res) => (this.info = res));
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.isCollapsed = true;
  }
}
